<form>
  @if (address) {
    <div class="adress-form">
      <div class="form-row row">
        <div class="col-sm-6">
          <form-row-input
            [label]="'firstName'"
            [model]="address.firstName"
            (modelChange)="address.firstName = $event; addressChange.emit(address)"
            [dataCyAttribute]="'first-name'"
          ></form-row-input>
        </div>
        <div class="col-sm-6">
          <form-row-input
            [label]="'lastName'"
            [model]="address.lastName"
            (modelChange)="address.lastName = $event; addressChange.emit(address)"
            data-cy="last-name"
          ></form-row-input>
        </div>
      </div>
      <div class="form-row row">
        <div class="col-sm-6">
          <form-row-input
            [label]="'email'"
            [model]="address.email"
            (modelChange)="address.email = $event; addressChange.emit(address)"
            data-cy="email"
            [inputType]="'email'"
          >
          </form-row-input>
        </div>
        <div class="col-sm-6">
          <form-row-input
            [label]="'phone'"
            [model]="address.phone"
            (modelChange)="address.phone = $event; addressChange.emit(address)"
            data-cy="phone"
          ></form-row-input>
        </div>
      </div>
      <form-row-input
        [label]="'company.name'"
        [model]="address.companyName"
        (modelChange)="address.companyName = $event; addressChange.emit(address)"
        [dataCyAttribute]="'address-company-name'"
      ></form-row-input>
      <div class="form-row row">
        <div class="col-sm-6">
          <form-row-input
            [label]="'company.ic'"
            [model]="address.ic"
            [inputDisabled]="isCompanyRegisterLoading"
            (modelChange)="address.ic = $event; addressChange.emit(address)"
            data-cy="company-ic"
          >
            <company-register-lookup
              [ico]="address.ic"
              [country]="address.country"
              [currentValues]="address"
              (companyInfoLoaded)="applyCompanyInfo($event)"
              (loadingChange)="isCompanyRegisterLoading = $event"
            ></company-register-lookup>
          </form-row-input>
        </div>
        <div class="col-sm-6">
          <form-row-input
            [label]="'company.dic'"
            [model]="address.dic"
            (modelChange)="address.dic = $event; addressChange.emit(address)"
            data-cy="company-dic"
          ></form-row-input>
        </div>
      </div>
      <form-row-input
        [label]="'street'"
        [model]="address.street"
        (modelChange)="address.street = $event; addressChange.emit(address)"
        data-cy="street"
      ></form-row-input>
      <div class="form-row row">
        <div class="col-sm-8">
          <form-row-input
            [label]="'city'"
            [model]="address.city"
            (modelChange)="address.city = $event; addressChange.emit(address)"
            data-cy="city"
          ></form-row-input>
        </div>
        <div class="col-sm-4">
          <form-row-input
            [label]="'zip'"
            [model]="address.zip"
            (modelChange)="address.zip = $event; addressChange.emit(address)"
            data-cy="zip"
          ></form-row-input>
        </div>
      </div>
      <div class="form-row row">
        <div class="col-sm-6">
          <form-row-select
            [label]="'country'"
            [model]="address.country"
            (modelChange)="selectCountry($event)"
            [options]="countriesWithNullOption"
            [optionKey]="'code'"
            [dataCyAttribute]="'country-combination'"
          ></form-row-select>
        </div>
        @if (states && states.length > 0 && (address.country === 'US' || address.country === 'CA')) {
          <div class="col-sm-6">
            <form-row-select
              [label]="'state'"
              [(model)]="address.state"
              [options]="states"
              [optionKey]="'code'"
              [dataCyAttribute]="'state'"
            ></form-row-select>
          </div>
        }
        @if (!states.length || (address.country !== 'US' && address.country !== 'CA')) {
          <div class="col-sm-6">
            <form-row-input
              [label]="'shopAddressId'"
              [icon]="'far-hashtag'"
              [(model)]="address.branchId"
              data-cy="shop-id"
            ></form-row-input>
          </div>
        }
      </div>
      @if (states && states.length > 0 && (address.country === 'US' || address.country === 'CA')) {
        <form-row-input
          [label]="'shopAddressId'"
          [icon]="'far-hashtag'"
          [(model)]="address.branchId"
          data-cy="shop-id"
        ></form-row-input>
      }
    </div>
  }
</form>
